import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { COMPANIES_ID } from 'projects/common/src/app/enumerables/companies-id';
import { IMachineType } from 'projects/common/src/app/interfaces/machine-type';
import { LanguageService } from 'projects/common/src/app/services/parameters';
import { IFilter } from '../../../interfaces/filter-config';
import { FilterHandlerService } from '../../../services/filter/filter-handler.service';
import { GoogleAnalyticsService } from '../../../services/google/google-analytics.service';
import { UserDataService } from '../../../services/parameter';
import { MachineCollectionService } from '../../../services/parameter/machine-collection/machine-collection.service';
import { PermissionService } from '../../../services/parameter/permission/permission.service';

@Component({
  selector: 'filter-machine-type',
  templateUrl: './filter-machine-type.component.html',
  styleUrls: ['./filter-machine-type.component.scss'],
})
export class FilterMachineTypeComponent implements OnInit, AfterViewInit {
  @Input() public filter: IFilter;

  @Output() public machineTypesChanged: EventEmitter<IMachineType[]>;

  private readonly PERMISSION = 'FILTRO-EQUIPO';
  public machineTypes: any[] | any;
  public selectedOption: any[];

  constructor(
    private machineCollectionService: MachineCollectionService,
    private userDataService: UserDataService,
    private filterHandlerService: FilterHandlerService,
    private languageService: LanguageService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private permissionService: PermissionService,
  ) {
    this.machineTypes = [];
    this.selectedOption = [];
    this.machineTypesChanged = new EventEmitter<IMachineType[]>();
  }

  /**
   * Init app
   */
  public ngOnInit(): void {
    if (this.filter.uniqueSelection) {
      // this.filter.uniqueSelection.imageActive = `${this.filter.uniqueSelection.name.toLowerCase()}-filter-dark`;
      this.filter.uniqueSelection.name = this.processMachineName(this.filter.uniqueSelection);

      this.machineTypes = [this.filter.uniqueSelection];
      this.selectedOption = this.filter.uniqueSelection.machineTypeId;
      this.changeSelectedOption(this.filter.uniqueSelection);
    } else {
      this.machineCollectionService.getByCompany(this.userDataService.get().company.id).subscribe(
        (machines: IMachineType[]) => {
          if (machines.length === 1) {
            this.filter = {
              required: true,
              uniqueSelection: {
                code: machines[0].code,
                disabled: null,
                hasProduction: true,
                level: 0,
                machineTypeId: machines[0].machineTypeId,
                name: machines[0].name,
              },
              value: machines[0].machineTypeId,
            };

            this.filter.uniqueSelection.name = this.processMachineName(this.filter.uniqueSelection);
            this.machineTypes = [this.filter.uniqueSelection];
            this.selectedOption = this.filter.uniqueSelection.machineTypeId;
            this.changeSelectedOption(this.filter.uniqueSelection);
          }

          if (machines.length > 0) {
            for (const machine of machines as any[]) {
              // machine.imageActive = `${machine.name.toLowerCase()}-filter-dark`;
              // machine.imageInactive = `${machine.name.toLowerCase()}-filter-white`;

              if (this.filter.multiselect) {
                machine.selectedAllGroup = 'selectedAllGroup';
              }

              machine.name = this.processMachineName(machine);
            }
          }

          if (this.filter.isForVitalSigns) {
            this.machineTypes = machines.filter((v) => v.machineTypeId === 3 || v.machineTypeId === 7);
            this.machineTypes.unshift({ machineTypeId: -1, name: this.languageService.message('all'), code: -1 });
          }
          if (this.filter.isForMtv) {
            this.machineTypes = machines.filter((v) => v.machineTypeId === 3);
            this.selectedOption = this.machineTypes[0].machineTypeId;
            this.changeSelectedOption(this.machineTypes);
          } else {
            this.machineTypes = machines;
          }
          if (this.filter.isForDm) {
            // this.machineTypes = machines.filter((v) => v.machineTypeId === )
          }

          // Filter machine types by permission
          const permissions = this.permissionService.getPermissionByType(this.PERMISSION);
          if (permissions?.length > 0) {
            this.machineTypes = this.machineTypes.filter((machine) =>
              permissions.some((permission) => permission.object.toLowerCase() === machine.name.toLowerCase()),
            );
          }
        },
        () => {},
      );
    }
  }

  /**
   * Component after view init
   */
  public ngAfterViewInit(): void {
    this.filterHandlerService.clearFilter$.subscribe(() => {
      if (this.filter.isForMtv || this.filter.uniqueSelection) {
        // empty condition
      } else {
        this.selectedOption = [];
        this.changeSelectedOption([]);
      }
    });
  }

  /**
   * Function to emit the selected option changed
   *
   * @param $event Selected option
   */
  public changeSelectedOption($event: IMachineType[]): void {
    this.machineTypesChanged.emit($event);
    const filter = {
      filter_selected: 'filter_machine_type',
      value_selected: $event,
    };
    this.googleAnalyticsService.sendFilterEvent(filter);
  }

  /**
   * Function to change machine type names for HCM
   */
  public processMachineName(machineType: IMachineType): string {
    const companyId = this.userDataService.get().company.id;
    const isHcm = companyId === COMPANIES_ID.HCM;
    let typeName = machineType.name;

    if (machineType.name === 'Acunador') {
      typeName = 'Acuñador';
    }

    if (isHcm) {
      if (machineType.name === 'Jumbo') {
        typeName = 'Equipo de perforación';
      }
    }

    if (machineType.name === 'Scoop') {
      typeName = 'LHD';
    }

    return typeName;
  }
}
